import React from "react";

import { dFlex, flex1 } from "./styles";
import OnePanel from "./OnePanel";
import Title from "./Title";
import Text from "./Text";

const GradesRanks = ({ round, targets }) => {
  const metricTitles = {
    market_share: "Market Share",
    net_revenues: "Net Revenues",
    gross_margin: "Gross Margins",
    stock_price: "Share Price",
    roa: "Return on Assets (ROA)",
    roe: "Return on Equity (ROE)",
    earnings_per_share: "Earnings Per Share"
  };

  // Get the non-zero metrics from targets
  const getNonZeroMetrics = () => {
    if (!targets) return [];

    const metricsToCheck = [
      'market_share',
      'net_revenues',
      'gross_margin',
      'stock_price',
      'roa',
      'roe',
      'earnings_per_share'
    ];

    return metricsToCheck
      .filter(metric => {
        const value = parseFloat(targets[metric]);
        return value > 0;
      })
      .map(metric => metricTitles[metric]);
  };

  const activeMetrics = getNonZeroMetrics();

  return (
    <OnePanel title="Metrics That Drive Your Grade & Ranking">
      <div style={{ ...dFlex, alignItems: "flex-start" }}>
        <div style={flex1}>
          <Text>
            For Year{" "}
            {round <= 2 ? "1" : round === 3 ? "3" : "4 and beyond"},
            these are 4 metrics that will drive your team grade &amp; ranking
          </Text>
        </div>
        <div style={{ ...flex1, textAlign: "center" }}>
          {activeMetrics.map((metric, index) => (
            <Title key={metric}>
              {index + 1}. {metric}
            </Title>
          ))}
        </div>
      </div>
    </OnePanel>
  )
};

export default GradesRanks;



// WEBPACK FOOTER //
// ./src/components/analysis/GradesRanks.js